import React from 'react'
import { Modal } from 'antd'



import success from "../../assest/success.png"

import CustomButton from '../CustomButton'





const DeleteGroupNotification = ({ visible, onClose}) => {
  const cancel = () => {
    // setPlayerInfo({})
    onClose()
  }


  


  return (
    <Modal
      className='addnotification'
      title=''
      open={visible}
      onCancel={onClose}
      centered
     footer={[
      ]}
      
    >

   

<div className='notificationmain'>
<img className='successimg' src={success} alt=""></img>


<h3 className="successs">
Successfully Deleted!

    <p>Your Group has been deleted</p>
</h3>







<CustomButton onClick={cancel} text={'Continue'} />


</div>


   









    </Modal>
  )
}

export default DeleteGroupNotification
